export function common(controller , scene){
	const titlearea = document.getElementById('titlearea');	
	if(titlearea){
		setTimeout(function(){
			titlearea.classList.add('active');
		},600);
	}
}